import {Injectable} from '@angular/core';
import {Headers, Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {EmailAccount} from "../Entities/EmailAccount";
import {ConnectionService} from "./connection.service";
import {environment} from "../../environments/environment";
import {AppConfig} from "../app.config";

@Injectable()
export class EmailAccountService {

  private apiUrl;

  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/EmailAccounts';
  }


  create(emailAccount: EmailAccount): Observable<EmailAccount> {
    let headers = this.connectionService.GetAuthorizationHeader();
    return this.http.post(this.apiUrl, JSON.stringify(emailAccount),
      {headers: headers}).map(response => response.json() as EmailAccount);
  }

  //return all topics from the database. Can be called even if a user is not authenticated.
  getAll(): Observable<EmailAccount[]> {
    let headers = this.connectionService.GetAuthorizationHeader();
    return this.http
      .get(this.apiUrl, {headers : headers})
      .map(response => response.json() as EmailAccount[])
  }


  delete(emailAccount: EmailAccount): Observable<EmailAccount> {
    let headers = this.connectionService.GetAuthorizationHeader();
    return this.http.delete(this.apiUrl + "/" + emailAccount.ID,
      {headers: headers}).map(response => response.json() as EmailAccount);
  }


  //returns a Email with matching id from the database, if it exists. Else writes an error in the browsers console.
  get(id: string): Observable<EmailAccount> {
    let headers = this.connectionService.GetAuthorizationHeader();
    return this.http
      .get(this.apiUrl + "/" + id, {headers: headers})
      .map(response => response.json() as EmailAccount)
  }

  //Updates the Email in the database with matching id if any. Else writes an error in the browsers console.
  update(emailAccount: EmailAccount): Observable<EmailAccount> {
    let headers = this.connectionService.GetAuthorizationHeader();
    return this.http
      .put(this.apiUrl + "/" + emailAccount.ID, JSON.stringify(emailAccount), {headers: headers}).map(response => response.json() as EmailAccount);
  }

  getUserByUsername(user: EmailAccount): Observable<EmailAccount> {
    return this.http.get(this.apiUrl + '?email=' + user.username).map((response) => response.json() as EmailAccount);
  }


  //Writes an error message in the browsers console.
  private handleError(error: any): Promise<any> {
    console.error('An error was made - ', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/email-account.service.ts